import { ref } from 'vue'
import { defineStore } from 'pinia'

import { logout } from '@/services/auth/oidc'
import type { User } from '@/types/auth'

export const useAuthStore = defineStore('auth', () => {
  const currentUser = ref<User | undefined>(undefined)
  const signOut = async () => {
    setCurrentUser(undefined)
    await logout()
  }
  const setCurrentUser = (user: User | undefined) => {
    currentUser.value = user
  }
  return {
    currentUser,
    signOut,
    setCurrentUser,
  }
})
